import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import DropdownVoucherDynamicInput from '../../../../components/Dropdown/DropdownVoucherDynamicInput';
import { currencyFormate } from '../../../../components/Date_Formate_Utilitiy/Index';

export const JournalDynamicInputRow = ({
  valueLoop,
  setValueLoop,
  showBorder,
  handleChange,
  handleFocus,
  handleBlur,
  inputRefs,
  dropList,
  narr_ref,
  handleDropdownDynamicClick,
  handleKeyDown,
  isView
}) => {
  const modal_state = useSelector(state => state.common.modal_state);

  // Memoize the input handlers
  const getInputHandlers = useCallback((id, field) => ({
    onChange: (e) => handleChange(e, id, field, e.target.value),
    onKeyUp: (e) => handleChange(e, id, field, e.target.value),
    onFocus: (e) => handleFocus(e, id, field, e.target.value),
    onBlur: (e) => handleBlur(e, id, field, e.target.value),
    onKeyDown: (e) => handleKeyDown(e, id, field)
  }), [handleChange, handleFocus, handleBlur, handleKeyDown]);

  // Memoize balance display calculation
  const shouldShowBalance = useCallback((item) => {
    return item?.first !== '' &&
      item?.first !== 'End of List' &&
      item?.particular_ledger_balance !== null &&
      item?.particular_ledger_balance !== undefined &&
      item?.particular_ledger_balance !== '';
  }, []);

  const getBalanceDisplay = useCallback((balance) => {
    const balanceNum = parseFloat(balance);
    return {
      className: balanceNum < 0 ? 'color_red' : 'text-muted',
      suffix: balance === 0 ? '' : balanceNum < 0 ? ' Cr' : ' Dr'
    };
  }, []);

  const memoizedDropList = useMemo(() => {
    const isBalanced = valueLoop?.total_debit > 0 && Math.abs((valueLoop?.total_debit || 0) - (valueLoop?.total_credit || 0)) < 0.01;
    return isBalanced ? [{ ledger_name: 'End of List' }, ...dropList] : dropList;
  }, [dropList, valueLoop?.total_debit, valueLoop?.total_credit]);

  return (
    <div className='row p-0 m-0 mb-1'>
      {valueLoop?.data?.map((item, index) => {
        //console.log(item);
        const rowId = item?.id;
        const typeInputHandlers = getInputHandlers(rowId, 'credit_debit');
        const firstInputHandlers = getInputHandlers(rowId, 'first');
        const debitInputHandlers = getInputHandlers(rowId, 'debit_amount');
        const creditInputHandlers = getInputHandlers(rowId, 'credit_amount');
        const balanceDisplay = getBalanceDisplay(item?.particular_ledger_balance);

        return (
          <div
            key={rowId}
            className={`col-12 ${showBorder ? 'border-bottom border-dark' : ''}`}
            style={{ height: 40, backgroundColor: 'transparent' }}
          >
            <div className='row' style={{ height: 40 }}>

              <div className='col-1 m-0 p-0 container_of_voucher_input'>
                {item?.first !== 'End of List' && (
                  <input
                    type='text'
                    style={{ textAlign: 'right', paddingRight: 5, textTransform: 'capitalize' }}
                    name={`credit_debit_${rowId}`}
                    ref={el => {
                      if (!inputRefs.current[rowId]) {
                        inputRefs.current[rowId] = {};
                      }
                      inputRefs.current[rowId].credit_debit = el;
                    }}
                    className='voucher_entry_account_input'
                    value={item?.credit_debit || (index === 0 ? 'DR' : '')}
                    disabled={isView}
                    {...typeInputHandlers}
                  />
                )}
              </div>
              <div className='col-4 m-0 p-0 container_of_voucher_input'>
                <input
                  type='text'
                  name={`first_${rowId}`}
                  ref={el => {
                    if (!inputRefs.current[rowId]) {
                      inputRefs.current[rowId] = {};
                    }
                    inputRefs.current[rowId].first = el;
                  }}
                  className='voucher_entry_account_input'
                  value={item?.first || ''}
                  onChange={(e) => handleChange(e, rowId, 'first', e.target.value)}
                  onKeyUp={(e) => handleChange(e, rowId, 'first', e.target.value)}
                  onFocus={(e) => handleFocus(e, rowId, 'first', e.target.value)}
                  onBlur={(e) => handleBlur(e, rowId, 'first', e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, rowId, 'first')}
                  disabled={isView}
                />
              </div>

              {modal_state[`first${rowId}`] && (
                <DropdownVoucherDynamicInput
                  title={'List of Ledger Account'}
                  state={modal_state[`first${rowId}`]}
                  data={valueLoop}
                  setData={setValueLoop}
                  input_value={item?.first}
                  input_key={'first'}
                  input_id={'particular_ledger_id'}
                  input_blc={'particular_ledger_balance'}
                  rawData={memoizedDropList}
                  index={index}
                  rowId={rowId}
                  modal_id={rowId}
                  ref={inputRefs.current[rowId]?.first}
                  refs={inputRefs}
                  narr_ref={narr_ref}
                  isDynamic={true}
                  handleDropdownClick={handleDropdownDynamicClick}
                />
              )}

              <div className='col-3' />

              <div className='col-2 m-0 p-0 container_of_voucher_input'>
                {(item?.first !== 'End of List' && (item?.credit_debit?.toLowerCase() === 'dr' || (index === 0 && !item?.credit_debit))) && (
                  <input
                    type='text'
                    style={{ textAlign: 'right', paddingRight: 5 }}
                    name={`debit_amount_${rowId}`}
                    ref={el => {
                      if (!inputRefs.current[rowId]) {
                        inputRefs.current[rowId] = {};
                      }
                      inputRefs.current[rowId].debit_amount = el;
                    }}
                    className='voucher_entry_account_input'
                    value={item?.debit_amount || ''}
                    disabled={isView}
                    {...debitInputHandlers}
                  />
                )}
              </div>
              <div className='col-2 m-0 p-0 container_of_voucher_input'>
                {(item?.first !== 'End of List' && item?.credit_amount !== undefined && item?.credit_debit?.toLowerCase() === 'cr') && (
                  <input
                    type='text'
                    style={{ textAlign: 'right', paddingRight: 5 }}
                    name={`credit_amount_${rowId}`}
                    ref={el => {
                      if (!inputRefs.current[rowId]) {
                        inputRefs.current[rowId] = {};
                      }
                      inputRefs.current[rowId].credit_amount = el;
                    }}
                    className='voucher_entry_account_input'
                    value={item?.credit_amount || ''}
                    disabled={isView}
                    {...creditInputHandlers}
                  />
                )}
              </div>

              <div className='col-6 m-0 ms-5'>
                {shouldShowBalance(item) && (
                  <div className='row' style={{ height: 19.5, marginLeft: '20%' }}>
                    <div className='col-1 p-0 m-0 font_size' style={{ textAlign: 'left', width: '11%' }}>
                      Cur Bal:
                    </div>
                    <div className='col-2 m-0 p-0 font_size' style={{ textAlign: 'right', height: 19.5 }}>
                      <span className={balanceDisplay.className}>
                        {currencyFormate(item?.particular_ledger_balance)}
                      </span>
                    </div>
                    <div className='col-2 m-0 p-0 ps-1 font_size' style={{ textAlign: 'left', height: 19.5 }}>
                      <span className={balanceDisplay.className}>
                        {balanceDisplay.suffix}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};